import { useMemo } from 'react';
import { safelyAppendAdditionalUserAddOn, useGetAdditionalUsersAddOn } from './use-get-additional-users-addon';
import { useGetAddOnsToRemove } from './use-get-addons-to-remove';
import { ShipmentVolume } from '../../../../../../constants/features';
import { ActivationTiming } from '../../manage-subscription-drawer/constants';

const getAddOnsToPurchase = (promotionalPlanShipmentLimit) => [
  {
    code: ShipmentVolume,
    quantity: promotionalPlanShipmentLimit,
    activationTiming: ActivationTiming.IMMEDIATELY,
  },
];

/**
 * @param {object} args
 * @param {number} args.promotionalPlanShipmentLimit
 * @returns {{ addOnsToRemove: object[], addOnsToPurchase: object[] }}
 */
export const useGetAddOnsForPayload = ({ promotionalPlanShipmentLimit }) => {
  const addOnsToPurchase = getAddOnsToPurchase(promotionalPlanShipmentLimit);
  const addOnsToRemove = useGetAddOnsToRemove();

  const { additionalUserAddOn, shouldActOnAdditionalUsers } = useGetAdditionalUsersAddOn();

  if (shouldActOnAdditionalUsers) {
    const addOnArrayForAdditionalUsers = additionalUserAddOn.quantity ? addOnsToPurchase : addOnsToRemove;
    safelyAppendAdditionalUserAddOn(additionalUserAddOn, addOnArrayForAdditionalUsers);
  }

  return useMemo(() => ({ addOnsToRemove, addOnsToPurchase }), [addOnsToPurchase, addOnsToRemove]);
};
